import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { PdaCustomersPage } from '@/features/pda-customers/pda-customers-page';

export const Route = createFileRoute('/_app/pda-customers')({
  component: () => (
    <RequireService service="PDA_CUSTOMER_LIST">
      <PdaCustomersPage />
    </RequireService>
  ),
});
